<template>
  <div class="item__form">
    <div class="price-calculator">
      <vs-input
        type="number"
        size="large"
        label="Count"
        v-model="count"
        @input="updatePriceFields($event, 'count')"
      ></vs-input>
      <span> x </span>
      <vs-input
        type="number"
        size="large"
        label="Price per unit"
        v-model="price_per_unit"
        @input="updatePriceFields($event, 'price_per_unit')"
      ></vs-input>
      <span> = </span>
      <vs-input
        type="number"
        size="large"
        label="Total cost"
        v-model="price"
        @input="updatePriceFields($event, 'price')"
      ></vs-input>
    </div>
    <div class="field">
      <label for="">Purchased date</label>
      <v-date-picker
        v-model="purchased"
        mode="date"
        ref="calendar"
        label="Purchased"
      >
        <template v-slot="{ inputValue, inputEvents }">
          <div>
            <vs-input
              class="calendar-input"
              :value="`${inputValue}`"
              v-on="inputEvents"
              size="large"
            />
          </div>
        </template>
      </v-date-picker>
    </div>
    <div class="save-popup-button">
      <vs-button icon="save" @click="saveTransaction">Save</vs-button>
    </div>
  </div>
</template>

<script>

export default {
  name: 'TransactionForm',
  props: ['transaction', 'itemId'],
  data() {
    let data = {
      count: null,
      price_per_unit: null,
      price: null,
      purchased: new Date(),
      transaction_type: 1,
    }
    if (this.transaction && this.transaction.id) {
      data = { ...this.transaction }
      if (data.purchased) {
        data.purchased = this.$moment(data.purchased * 1000)
      }
    }

    return { ...data }
  },
  methods: {
    saveTransaction: function () {
      // TODO: avatar to base64
      let {
        count,
        price_per_unit,
        price,
        purchased,
        transaction_type,
      } = this

      const data = {
        count,
        price_per_unit,
        price,
        purchased: purchased.getTime() / 1000,
        transaction_type,
      }

      if (this.id) data.id = this.id
      this.$store
        .dispatch('items/saveTransactionsAction', {
          transaction: data,
          itemId: this.itemId,
        })
        .then(() => {
          this.$emit('closePopup', this.closePopup)
        })
    },
    normalizeNumericValue(value) {
      if (value === '' || value === null || value === undefined) return null
      const parsedValue = parseFloat(value)
      return Number.isNaN(parsedValue) ? null : parsedValue
    },
    updatePriceFields(changedValue, changedField) {
      const count = this.normalizeNumericValue(this.count)
      const pricePerUnit = this.normalizeNumericValue(this.price_per_unit)
      // const price = this.normalizeNumericValue(this.price)

      if (changedField === 'count') {
        if (
          pricePerUnit !== null &&
          pricePerUnit !== undefined &&
          pricePerUnit !== 0
        ) {
          this.price = changedValue * pricePerUnit
        }
      }

      if (changedField === 'price_per_unit') {
        if (count !== null && count !== undefined && count !== 0) {
          this.price = count * changedValue
        }
      }

      if (changedField === 'price') {
        if (count !== undefined && count !== null && count !== 0) {
          this.price_per_unit = Number((changedValue / count).toFixed(2))
        } else if (
          pricePerUnit !== undefined &&
          pricePerUnit !== null &&
          pricePerUnit !== 0
        ) {
          this.count = Number((changedValue / pricePerUnit).toFixed(2))
        }
      }
    },
  },
}
</script>

<style lang="scss">
</style>
